import MaskedTextField from '@/common/components/MaskedTextField'
import TextArea from '@/common/components/TextArea'
import TextField from '@/common/components/TextField'
import { numericRegexMask } from '@/common/constants/masks.constant'
import { TmaisFaqFormSchema } from '@/features/tmaisFaqs/schemas/form.schema'
import { Controller, UseFormReturn } from 'react-hook-form'

type TmaisFaqFormProps = {
  form: UseFormReturn<TmaisFaqFormSchema>
  isSubmitting?: boolean
  showPosition?: boolean
}

const TmaisFaqForm = ({ form, isSubmitting, showPosition = true }: TmaisFaqFormProps) => {
  const {
    control,
    register,
    formState: { errors },
  } = form

  return (
    <div className="flex flex-col gap-4">
      <TextField
        label="Pergunta"
        markAsRequired
        maxLength={256}
        errorMessage={errors?.question?.message}
        disabled={isSubmitting}
        {...register('question')}
      />

      <TextArea
        label="Resposta"
        markAsRequired
        maxLength={1024}
        rows={3}
        errorMessage={errors?.answer?.message}
        disabled={isSubmitting}
        {...register('answer')}
      />

      {showPosition && (
        <Controller
          control={control}
          name="position"
          render={({ field }) => (
            <MaskedTextField
              {...field}
              label="Posição"
              markAsRequired
              mask={numericRegexMask(4)}
              className="w-40"
              errorMessage={errors.position?.message || undefined}
              disabled={isSubmitting}
            />
          )}
        />
      )}
    </div>
  )
}

export default TmaisFaqForm
